/*
IFrame Resizer light version
Based on [iframe-resizer](https://github.com/davidjbradshaw/iframe-resizer)
- this version lib to have the base/minimal features
- only use default values
- force resize the iframe when parent window is resized

To avoid memory leaks, only iframes (with a specific classname) that are attached to the document are handled
Window events listeners are shared.
If the iframe is removed from document (detached nodes) subsequent message events are ignored
*/

const IFRAME_RESIZER_PREFIX = "[iFrameSizer]";

function getOrigin(url){
  return (url.match(/^https?:\/\/[^\/]+/) || ["null"])[0];// there is no native way to get that (iframe.contentWindow.origin, but doesn't reflect the current src - ex: when  - and not well supported)
}

let instanceCounter = 0;

export default class {
  constructor({el}){
    this._sendInitMessage = this._sendInitMessage.bind(this);
    this._messageTimeoutHandler = this._messageTimeoutHandler.bind(this);
    this._messageHandler = this._messageHandler.bind(this);
    this._debounceResizeRequest = this._debounceResizeRequest.bind(this);
    this._requestIFrameResize = this._requestIFrameResize.bind(this);
    this._iframe = el;
    this._id = el.id || "iframeResizer" + (++instanceCounter);
    this._origin = getOrigin(this._iframe.src);
    this._connectionState = "init";
    this._messageTimeoutID = 0;
    this._initIntervalID = 0;
    this._initialize();
    // FIXME support disconnectedCallback
    window.addEventListener("message", this._messageHandler);
    window.addEventListener("resize", this._debounceResizeRequest);
  }

  _debounceResizeRequest(){
    // RAF is used for debounce to next animation frame
    requestAnimationFrame(this._requestIFrameResize);
  }

  // Resize message
  _requestIFrameResize(){
    const message = ["resize"];
    // If the channel is init, wait for it, if closed do nothing
    if(this._connectionState === "open"){
      return;
    }

    // <prefix>resize
    // https://github.com/davidjbradshaw/iframe-resizer/blob/master/src/iframeResizer.contentWindow.js#L1076-L1084
    this._postMessage(message, 100);// 100ms should be enough for postMessage roundtrip (window->iframe+iframe->window)
  }

  _initialize() {
    this._clearTimers();
    this._connectionState = "init";
    this._initIntervalID = setInterval(this._sendInitMessage, 100);// try to contact the other side
    this._sendInitMessage();
  }

  _sendInitMessage(iframe){
    // Init message
    // https://github.com/davidjbradshaw/iframe-resizer#options
    // <prefix><iframe_id>:<body_margin_v1>:<calculate_width>:<logging>:<interval>:<auto_resize>:<body_margin>:<height_calc_mode>:<body_background>:<body_padding>:<tolerance>:<in_page_links>:<resize_from>:<width_calc_mode>
    // Example: [iFrameSizer]myIFrameID:8:false:false:32:true:true:null:bodyOffset:null:null:0:false:parent:scroll
    // https://github.com/davidjbradshaw/iframe-resizer/blob/da4ac20121304f7646ca0c888a4a885e0675380a/src/iframeResizer.contentWindow.js#L194-L216
    // https://github.com/davidjbradshaw/iframe-resizer/blob/268d3733ae3758e103383ba242d5bf6d8cdbb11a/src/iframeResizer.js#L690-L706
    // Since the script is retro compatible, we can send only a part of the message, others values will be defaulted
    // <prefix><iframe_id>:<body_margin_v1>:<calculate_width>
    // https://github.com/davidjbradshaw/iframe-resizer/blob/da4ac20121304f7646ca0c888a4a885e0675380a/src/iframeResizer.contentWindow.js#L1070-L1074
    this._postMessage([this._id, 8, false], 5000);// 5s that let the iframe resize to be loaded and initialized
  }

  /**
   * Send message to iframe
   * @param {Array} message
   * @param {number} [timeout] If provided, the target must respond within the given time
   */
  _postMessage(message, timeout = 0){
    if(timeout){
      clearTimeout(this._messageTimeoutID);// -> previous unanswered message timeout is ignored
      this._messageTimeoutID = setTimeout(this._messageTimeoutHandler, timeout);
    }

    try{
      this._iframe.contentWindow.postMessage(IFRAME_RESIZER_PREFIX + message.join(":"), this._origin);
    }catch(error){
      // ignore origin mismatch errors (the iframe is not loaded yet = iframe content window origin is the same as its parent, the src change, etc.)
    }
  }

  /**
   * The iframeReizer doesn't respond before timeout
   * @param iframe
   */
  _messageTimeoutHandler(){
    this._clearTimers();
    this._connectionState = "close";
  }

  _clearTimers(){
    clearInterval(this._initIntervalID);
    clearTimeout(this._messageTimeoutID);
  }

  _messageHandler(event){
    // Test if it's not from that iframe
    if(!event.source || event.source !== this._iframe.contentWindow && event.source.parent !== this._iframe.contentWindow){
      return;
    }

    const message = String(event.data);
    // Message doesn't come from iframeresizer lib, ignore it
    if(!message.startsWith(IFRAME_RESIZER_PREFIX)){
      return;
    }

    this._connectionState = "open";
    this._clearTimers();

    // <prefix><iframe_id>:<height>:<width>:<event>
    // https://github.com/davidjbradshaw/iframe-resizer/blob/da4ac20121304f7646ca0c888a4a885e0675380a/src/iframeResizer.contentWindow.js#L993-L1000
    const [id, height] = message.slice(IFRAME_RESIZER_PREFIX.length).split(":");

    // Is not the same origin, that means the iframe src has been changed
    if(event.origin !== this._origin || id !== this._id){
      // Reinitialize
      this._initialize();
      return;
    }

    this._iframe.style.height = height + "px";
  }
}
